<template>
  <div class="pb-20">
    <h1 class="font-display text-gray-900 font-bold text-basicTitle pb-9 l150:pb-5 ltr:ml-7 ltr:l150:ml-0 rtl:mr-7 rtl:l150:mr-0 md:!mx-2">
      {{ $t('dashboard').tTitle() }}
    </h1>
    <div id="boxes" class="flex w-[98%] l150:w-full gap-8 px-2 pb-2.5 md:pt-2.5 mb-6 overflow-hidden overflow-x-auto ltr:ml-2 ltr:md:ml-0 rtl:mr-2 rtl:md:mr-0">
      <div class="w-56 l150:w-1/2 l150:grow h-auto l150:h-[8.2rem] bg-white rounded-lg shadow-ts1 group flex-shrink-0 l150:flex-shrink">
        <div class="h-full flex flex-col l150:flex-row justify-center l150:justify-start p-5 l150:p-8 relative gap-3 l150:gap-6">
          <div class="h-[70px] w-[70px] rounded-full bg-blue bg-opacity-25 shrink-0 flex justify-center items-center">
            <img class="h-8 w-8" src="../assets/img/internal-transfer-quickmenu.svg" />
          </div>
          <div class="grow flex justify-between">
            <div>
              <p class="text-gray-900 text-sm leading-6 font-medium">{{ $t('wallet_balance').tTitle() }}</p>
              <p class="pt-1 text-blue font-bold text-4xl">{{ $formatMoney(walletBalance, currencySymbols[User.wallet.currency]) }}</p>
            </div>
            <img
              class="h-5 w-5 absolute l150:relative top-5 l150:top-auto ltr:right-5 ltr:l150:right-auto rtl:left-5 rtl:l150:left-auto"
              src="../assets/img/internal-transfer-quickmenu.svg"
            />
          </div>

          <div
            class="h-full w-full bg-blue absolute inset-0 flex justify-center items-center rounded-lg bg-opacity-90 opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100"
          >
            <router-link
              :to="'/' + Language + '/finance/internal-transfer'"
              class="border border-white border-solid bg-blue appearance-none text-white rounded-md text-center px-2 min-w-[160px] h-12 pt-3 font-bold text-base m-auto table"
              >{{ $t('internal_transfer').tTitle() }}</router-link
            >
          </div>
          <!-- <div class="pt-1.5 flex items-center">
                <div>
                  <img
                    v-if="walletBalance>=1000000"
                    class="h-4 w-4"
                    src="../assets/img/up.svg"
                  />
                  <img
                    v-else
                    class="h-4 w-4"
                    src="../assets/img/down.svg"
                  />
                </div>
                <p class="text-gray-600 text-[0.7rem] ml-2"><span
                    :class="[walletBalance>=1000000 ? 'text-green' : 'text-gray-900']"
                    class="pr-1"
                  >{{ $formatMoney(walletBalance, currencySymbols[User.wallet.currency]) }}</span> {{$t('last_five_days')}}</p>
              </div> -->
        </div>
      </div>
      <div class="w-56 l150:w-1/2 l150:grow h-auto l150:h-[8.2rem] bg-white rounded-lg shadow-ts1 relative group flex-shrink-0 l150:flex-shrink">
        <div class="h-full flex flex-col l150:flex-row justify-center l150:justify-start p-5 l150:p-8 relative gap-3 l150:gap-6">
          <div class="h-[70px] w-[70px] rounded-full bg-green bg-opacity-25 shrink-0 flex justify-center items-center">
            <img class="h-8 w-8" src="../assets/img/deposit.svg" />
          </div>
          <div class="grow flex justify-between">
            <div>
              <p class="text-gray-900 text-sm leading-6 font-medium">{{ $t('deposits') }}</p>
              <p class="pt-1 text-green font-bold text-4xl">{{ $formatMoney(TotalDeposited, currencySymbols[User.wallet.currency]) }}</p>
            </div>
            <img class="h-5 w-5 absolute l150:relative top-5 l150:top-auto ltr:right-5 ltr:l150:right-auto rtl:left-5 rtl:l150:left-auto" src="../assets/img/deposit.svg" />
          </div>
        </div>
        <div
          class="h-full w-full bg-green absolute inset-0 flex justify-center items-center rounded-lg bg-opacity-90 opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100"
        >
          <router-link
            :to="'/' + Language + '/finance'"
            class="border border-white border-solid bg-green appearance-none text-white rounded-md text-center w-40 h-12 pt-3 font-bold text-base m-auto table"
            >{{ $t('deposit').tTitle() }}</router-link
          >
        </div>
      </div>
      <div class="w-56 l150:w-1/2 l150:grow h-auto l150:h-[8.2rem] bg-white rounded-lg shadow-ts1 relative group flex-shrink-0 l150:flex-shrink">
        <div class="h-full flex flex-col l150:flex-row justify-center l150:justify-start p-5 l150:p-8 relative gap-3 l150:gap-6">
          <div class="h-[70px] w-[70px] rounded-full bg-gray-900 bg-opacity-25 shrink-0 flex justify-center items-center">
            <img class="h-8 w-8" src="../assets/img/withdraw.svg" />
          </div>
          <div class="grow flex justify-between">
            <div>
              <p class="text-gray-900 text-sm leading-6 font-medium">{{ $t('withdrawals').tTitle() }}</p>
              <p class="pt-1 text-gray-900 font-bold text-4xl">{{ $formatMoney(TotalWithdrawals, currencySymbols[User.wallet.currency]) }}</p>
            </div>
            <img class="h-5 w-5 absolute l150:relative top-5 l150:top-auto ltr:right-5 ltr:l150:right-auto rtl:left-5 rtl:l150:left-auto" src="../assets/img/withdraw.svg" />
          </div>
        </div>
        <div
          class="h-full w-full bg-gray-900 absolute inset-0 flex justify-center items-center rounded-lg bg-opacity-90 opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100"
        >
          <router-link
            :to="'/' + Language + '/finance/withdraw'"
            class="border border-white border-solid bg-gray-900 appearance-none text-white rounded-md text-center w-40 h-12 pt-3 font-bold text-base m-auto table"
            >{{ $t('withdrawal').tTitle() }}</router-link
          >
        </div>
      </div>
    </div>
    <div class="flex justify-center items-start flex-col l150:flex-row gap-7">
      <div class="w-full l150:w-[calc(66.66%+22px)] overflow-hidden px-2 l150:h-auto flex flex-col l150:justify-around pb-5">
        <div class="bg-white rounded-lg shadow-ts1 pt-4 pb-3 block l150:hidden mx-2 md:mx-0 mb-7">
          <div class="pb-4 border-b border-solid border-gray-400">
            <div>
              <p class="ltr:pl-5 rtl:pr-5 text-gray-900 font-display font-bold text-xl leading-none">{{ $t('quick_links') }}</p>
            </div>
          </div>
          <div class="w-auto overflow-hidden pt-5" id="carousel1">
            <VueSlickCarousel v-bind="carouselSettings" @init="onInitCarousel" @reInit="onInitCarousel" class="w-[91vw] md:w-[71vw]">
              <div class="pb-3">
                <p class="item-title text-gray-900 text-xs leading-[18px] text-center mb-3 font-medium">{{ $t('internal_transfer').tTitle() }}</p>
                <div class="item-icon h-[70px] w-[70px] bg-white rounded-xl shadow-ts3 m-auto mt-5">
                  <img class="w-full" src="../assets/img/internal-transfer.svg" />
                </div>

                <router-link :to="'/' + Language + '/finance/internal-transfer'" class="active-icon h-[82px] w-[82px] bg-gray-900 rounded-xl shadow-ts3 m-auto hidden">
                  <img class="w-full" src="../assets/img/internal-transfer-b.svg" />
                </router-link>
              </div>
              <div class="pb-3">
                <p class="item-title text-gray-900 text-sm text-center mb-3 font-medium">{{ $t('account_list').tTitle() }}</p>
                <div class="item-icon h-[70px] w-[70px] bg-white rounded-xl shadow-ts3 m-auto mt-5">
                  <img class="w-full" src="../assets/img/account-list.svg" />
                </div>
                <router-link :to="'/' + Language + '/trading-account'" class="active-icon h-[82px] w-[82px] bg-gray-900 rounded-xl shadow-ts3 m-auto hidden">
                  <img class="w-full" src="../assets/img/account-list-b.svg" />
                </router-link>
              </div>
              <!-- <div class="pb-3">
                <p class="item-title text-gray-900 text-sm text-center mb-3 font-medium">{{ $t('video_courses') }}</p>
                <div class="item-icon h-[70px] w-[70px] bg-white rounded-xl shadow-ts3 m-auto mt-5">
                  <img class="w-full" src="../assets/img/video-courses.svg" />
                </div>
                <div class="active-icon h-[82px] w-[82px] bg-gray-900 rounded-xl shadow-ts3 m-auto hidden">
                  <img class="w-full" src="../assets/img/video-courses-b.svg" />
                </div>
              </div> -->
              <div class="pb-3">
                <p class="item-title text-gray-900 text-sm text-center mb-3 font-medium">{{ $t('transactions') }}</p>
                <div class="item-icon h-[70px] w-[70px] bg-white rounded-xl shadow-ts3 m-auto mt-5">
                  <img class="w-full" src="../assets/img/transactions-icon.svg" />
                </div>
                <router-link :to="'/' + Language + '/finance/payment-history'" class="active-icon h-[82px] w-[82px] bg-gray-900 rounded-xl shadow-ts3 m-auto hidden">
                  <img class="w-full" src="../assets/img/transactions-icon-b.svg" />
                </router-link>
              </div>
              <div class="pb-3">
                <p class="item-title text-gray-900 text-sm text-center mb-3 font-medium">{{ $t('profile') }}</p>
                <div class="item-icon h-[70px] w-[70px] bg-white rounded-xl shadow-ts3 m-auto mt-5">
                  <img class="w-full" src="../assets/img/my-settings-icon.svg" />
                </div>
                <router-link :to="'/' + Language + '/profile'" class="active-icon h-[82px] w-[82px] bg-gray-900 rounded-xl shadow-ts3 m-auto hidden">
                  <img class="w-full" src="../assets/img/my-settings-icon-b.svg" />
                </router-link>
              </div>
            </VueSlickCarousel>
          </div>
        </div>

        <div class="w-auto lg:w-full bg-white rounded-lg shadow-ts1 pt-5 mb-7 mx-2 lg:mx-0 lg:h-[615px]">
          <div class="w-full pb-4 border-b border-gray-400 border-solid">
            <div class="w-full flex justify-between items-start">
              <h2 class="ltr:pl-5 ltr:md:pl-8 rtl:pr-5 rtl:md:pr-8 text-gray-900 font-display font-bold text-xl leading-none">
                {{ $t('account_list').tTitle() }}
              </h2>
              <div class="md:hidden ltr:pr-5 rtl:pl-5">
                <router-link :to="'/' + Language + '/trading-account'" class="font-semibold text-gray-900 text-sm">{{ $t('see_more') }}</router-link>
              </div>
            </div>
          </div>
          <div class="flex justify-between mt-6 pb-8 px-5 l150:px-8">
            <div class="w-[48%] xl:w-1/3">
              <!-- <div class="w-36 inline-block relative">
                <select
                  v-model="selectedPlatform"
                  name="platform"
                  class="rtl:bg-left bg-none py-3 bg-white text-blue border border-gray-300 border-solid focus:border focus:border-gray-300 focus:border-solid focus:outline-none focus:ring-0 cursor-pointer"
                >
                  <option value="all">{{ $t('platform').tTitle() }}</option>
                  <option value="mt4">MT4</option>
                  <option value="mt5">MT5</option>
                  <option value="pamm">PAMM</option>
                  <option value="trl">Tradelocker</option>
                </select>
                <div class="select-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div> -->
              <Select v-model="selectedPlatform" name="platform" placeholder="platform" :options="platforms" :InputContainerClass="'max-w-40'" :mode="'secondary'" />
            </div>
            <div class="w-full hidden xl:flex">
              <div class="w-full md:w-10/12 max-w-[400px] px-5 l150:px-0 m-auto">
                <ButtonGroup :options="['all', 'live', 'demo']" :selectedOption="selectedAccountType" @click="opt => (selectedAccountType = opt)" />
              </div>
            </div>
            <div class="w-[48%] xl:w-1/3">
              <Button @click="showCAModal" customClasses="!max-w-40 ltr:float-right rtl:float-left">
                {{ $t('create_account') }}
              </Button>
            </div>
          </div>

          <div class="w-full mb-6 table m-auto xl:hidden px-5">
            <ButtonGroup :options="['all', 'live', 'demo']" :selectedOption="selectedAccountType" @click="opt => (selectedAccountType = opt)" />
          </div>
          <Carousel showMoreRoute="trading-account" navPosition="bottom" :showNavigationBar="isMobile ? filteredTradingAccounts.length > 1 : filteredTradingAccounts.length > 2">
            <div
              v-for="item in filteredTradingAccounts"
              :key="item.external_id"
              :id="item.external_id"
              class="w-80 flex-shrink-0 rounded-lg border border-gray-300 border-solid"
              :class="isMobile && filteredTradingAccounts.length <= 1 ? 'w-full' : ''"
            >
              <div class="p-4 relative noUserSelect" :class="[item.account_type == '' || item.account_type.toLowerCase() == 'archived' ? 'opacity-60' : '']">
                <div
                  v-if="item.account_type.toLowerCase().includes('slave of')"
                  class="absolute -top-2.5 right-4 h-5 px-2.5 flex justify-center items-center bg-[#F0F3FF] border border-[#D3D3D3] border-solid rounded-xl text-[9px] text-gray-900 font-medium"
                >
                  {{ item.account_type.toLowerCase().replace('slave of', $t('attached_to')) }}
                </div>
                <div
                  v-if="item.copy_trading_following_providers.length>0"
                  class="absolute -top-2.5 right-4 h-5 px-2.5 flex justify-center items-center bg-[#F0F3FF] dark:bg-surface border border-[#D3D3D3] dark:border-divider border-solid rounded-xl text-[9px] text-gray-900 dark:text-white font-medium"
                >
                  <div v-if="item.copy_trading_following_providers.length > 2" class="w-auto flex justify-center text-left gap-0.5">
                    <span>{{ $t('copying') }} </span>
                    <span
                      v-for="(provider, index) in item.copy_trading_following_providers.slice(0, 2)"
                      :key="provider.provider_id"
                    >
                      <span
                        :class="provider.activated ? 'text-green' : 'text-red-500'"
                      >
                        {{ provider.provider_external_id }}
                      </span>

                      <span
                        v-if="index < item.copy_trading_following_providers.slice(0, 2).length - 1"
                      >
                        ,
                      </span>
                    </span>
                    <img
                      @click="showCopyTradingAttachedToTooltip = !showCopyTradingAttachedToTooltip"
                      src="../assets/img/plus-icon.svg"
                      class="relative overflow-visible float-right h-3 w-3 cursor-pointer maxXs:mb-auto ml-1"
                    />
                    <div
                      v-if="showCopyTradingAttachedToTooltip"
                      class="min-w-[138px] w-auto max-w-xs absolute ltr:left-[-2px] right-[-2px] rtl:right-0 top-[-1px] px-2.5 py-[3px] bg-[#F0F3FF] dark:bg-surface border border-[#D3D3D3] dark:border-divider rounded-xl z-20"
                    >
                      <img
                        @click="showCopyTradingAttachedToTooltip = !showCopyTradingAttachedToTooltip"
                        src="../assets/img/minus-icon.svg"
                        class="relative overflow-visible float-right h-3 w-3 cursor-pointer maxXs:mb-auto ml-1"
                      />
                      <p class="text-[9px] text-gray-900 dark:text-white font-medium whitespace-normal">
                        <span>{{ $t('copying') }} </span>
                        <span
                          v-for="(provider, index) in item.copy_trading_following_providers"
                          :key="provider.provider_id"
                        >
                          <span
                            :class="provider.activated ? 'text-green-500' : 'text-red-500'"
                          >
                            {{ provider.provider_external_id }}
                          </span>

                          <span
                            v-if="index < item.copy_trading_following_providers.length - 1"
                          >,</span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <span>{{ $t('copying') }} </span>
                    <span
                      v-for="(provider, index) in item.copy_trading_following_providers"
                      :key="provider.provider_id"
                    >
                      <span
                        :class="provider.activated ? 'text-green-500' : 'text-red-500'"
                      >
                        {{ provider.provider_external_id }}
                      </span>

                      <span
                        v-if="index < item.copy_trading_following_providers.length - 1"
                      >,</span>
                    </span>
                  </div>
                </div>
                <div class="flex mb-4">
                  <img v-if="item.account_type.toLowerCase() === 'archived'" class="h-[70px] w-[70px]" src="../assets/img/archived.svg" />
                  <img v-else-if="item.type == 'demo'" class="h-[70px] w-[70px]" src="../assets/img/demo.svg" />
                  <img v-else-if="item.account_type_identifier == 'silver'" class="h-[70px] w-[70px]" src="../assets/img/silver.svg" />
                  <img
                    v-else-if="item.account_type_identifier == 'gold-ecn' || item.account_type_identifier == 'gold-raw'"
                    class="h-[70px] w-[70px]"
                    src="../assets/img/gold.svg"
                  />
                  <img v-else-if="item.account_type_identifier == 'silver-islamic'" class="h-[70px] w-[70px]" src="../assets/img/silver-islamic.svg" />
                  <img v-else-if="item.account_type_identifier == 'gold-raw-is'" class="h-[70px] w-[70px]" src="../assets/img/islamic.svg" />
                  <img v-else-if="item.account_type_identifier == 'platinum-vip'" class="h-[70px] w-[70px]" src="../assets/img/platinum.svg" />
                  <img v-else-if="item.account_type_identifier == 'micro'" class="h-[70px] w-[70px]" src="../assets/img/micro.svg" />
                  <img v-else-if="item.account_type_identifier == 'pamm-investor'" class="h-[70px] w-[70px]" src="../assets/img/pamm-investor.svg" />
                  <img v-else-if="item.account_type_identifier == 'pamm-master'" class="h-[70px] w-[70px]" src="../assets/img/pamm-investor.svg" />
                  <img v-else-if="item.account_type_identifier == 'no-deposit-bonus'" class="h-[70px] w-[70px]" src="../assets/img/no-deposit-bonus.svg" />
                  <img v-else-if="item.account_type_identifier == 'trading-competition'" class="h-[70px] w-[70px]" src="../assets/img/trading-competition.svg" />
                  <img v-else-if="item.account_type_identifier == 'raw-bonus'" class="h-[70px] w-[70px]" src="../assets/img/raw-bonus.svg" />
                  <img v-else-if="item.account_type_identifier == 'copy-trading-follower'" class="h-[70px] w-[70px]" src="../assets/img/copy-trading-follower.svg" />
                  <img v-else-if="item.account_type_identifier == 'copy-trading-provider'" class="h-[70px] w-[70px]" src="../assets/img/copy-trading-provider.svg" />
                  <div class="w-full">
                    <div class="flex justify-between items-center">
                      <div
                        :class="[item.type == 'live' ? 'bg-green' : 'bg-gray-900']"
                        class="h-5 text-white text-xs font-semibold rounded-xl px-5 ltr:ml-4 rtl:mr-4 pt-0.5 inline-block"
                      >
                        {{ item.type.tTitle() }}
                      </div>
                      <div
                        v-if="item.account_type != '' && item.account_type.toLowerCase() != 'archived'"
                        @click="showActionsTooltip(item.external_id)"
                        class="tooltip-icon h-7 w-7 bg-white hover:bg-gray-400 text-center rounded-full transition-all duration-300 ease-in-out text-2xl text-gray-900 leading-4 cursor-pointer"
                      >
                        ...
                      </div>
                    </div>
                    <p class="text-gray-900 font-bold text-xl ltr:ml-4 rtl:mr-4">{{ item.external_id }}</p>
                    <p class="text-gray-900 text-[11px] ltr:ml-4 rtl:mr-4 font-medium">
                      {{
                        item.account_type == ''
                          ? $t('archived')
                          : item.account_type_identifier == 'silver-islamic'
                          ? 'Islamic'
                          : item.account_type_identifier == 'pamm-master'
                          ? 'Master'
                          : item.account_type_identifier == 'pamm-investor'
                          ? 'Investor'
                          : item.account_type
                      }}
                      / {{ item.platform == 'mt4' ? 'MetaTrader 4' : item.platform == 'mt5' ? 'MetaTrader 5' : item.platform == 'trl' ? 'Tradelocker' : 'PAMM' }}
                    </p>
                  </div>
                </div>
                <div class="w-full rounded-lg bg-blue bg-opacity-15 px-4 py-1.5 mb-3.5">
                  <p class="text-gray-900 text-sm leading-6 font-medium">{{ $t('account_balance').tTitle() }}</p>
                  <p class="pt-1 text-blue font-bold text-4xl">{{ $formatMoney(item.balance, currencySymbols[item.currency]) }}</p>
                </div>
                <div class="w-full flex space-x-3.5 rtl:space-x-reverse">
                  <div class="w-1/2 rounded-lg bg-blue bg-opacity-15">
                    <p class="text-gray-900 text-sm leading-4 font-medium pt-1 ltr:pl-4 rtl:pr-4">{{ $t('equity').tTitle() }}</p>
                    <p class="text-blue font-semibold text-base ltr:pl-4 rtl:pr-4 pb-1 leading-6">{{ $formatMoney(item.equity, currencySymbols[item.currency]) }}</p>
                  </div>
                  <div class="w-1/2 rounded-lg bg-blue bg-opacity-15">
                    <p class="text-gray-900 text-sm leading-4 font-medium pt-1 ltr:pl-4 rtl:pr-4">{{ $t('leverage').tTitle() }}</p>
                    <p class="text-blue font-semibold text-base ltr:pl-4 rtl:pr-4 pb-1 leading-6">1:{{ item.leverage }}</p>
                  </div>
                </div>
                <div :class="[!item.accept_bonus ? 'bg-[#e0e1e4]' : 'bg-[#def4ec]']" class="w-full rounded-lg flex gap-1 px-4 py-2 mt-3.5">
                  <p class="text-gray-900 text-sm font-semibold">{{ $t('bonus_120') }}:</p>
                  <p class="text-gray-900 font-medium text-sm">{{ !item.accept_bonus ? $t('no_bonus') : getTABonus(item.external_id) }}</p>
                </div>
                <div class="w-full mt-3.5">
                  <Button
                    mode="secondary"
                    customClasses="flex justify-center items-center !py-1 h-[30px]"
                    size="small"
                    v-if="item.transfer_locked && item.transfer_account_external_id != ''"
                    :disabled="item.account_type == '' || item.account_type.toLowerCase() == 'archived'"
                    @click="openTransferBackModal(item.external_id, item.equity)"
                  >
                    {{ $t('transfer').tTitle() }}
                  </Button>
                  <Button
                    v-else
                    mode="secondary"
                    size="small"
                    customClasses="!font-bold !py-1 h-[30px]"
                    :disabled="item.account_type == '' || item.account_type.toLowerCase() == 'archived'"
                  >
                    <router-link :to="'/' + Language + '/finance'">
                      {{ $t('deposit').tTitle() }}
                    </router-link>
                  </Button>
                </div>
                <div
                  v-if="item.account_type != '' && item.account_type.toLowerCase() != 'archived'"
                  class="actions-tooltip absolute top-[3.4rem] right-6 bg-white border border-gray-300 border-solid shadow-ts1 rounded-lg px-3 py-5 w-[240px]"
                  :class="{ hidden: activeTooltip !== item.external_id }"
                >
                  <Button
                    v-if="item.account_type_identifier != 'pamm-investor'"
                    @click="(activeTooltip = null), (changeTAPassword.TAID = item.external_id), (changeTAPassword.modalActive = true)"
                    mode="primary-white"
                    customClasses="leading-6 !font-normal !py-2 mb-2"
                  >
                    {{ $t('change_password').tTitle() }}
                  </Button>
                  <!-- <Button v-if="item.account_type_identifier != 'pamm-investor'" mode="primary-white" customClasses="leading-6 !font-normal !py-2 mb-2"> -->
                  <router-link
                    :to="'/' + Language + '/trading-account/download'"
                    class="block w-full rounded-md text-center focus:outline-none whitespace-nowrap bg-white text-gray-900 hover:bg-blue hover:text-white focus:ring-blue text-base px-3 leading-6 font-normal !py-2 mb-2"
                    @click="(activeTooltip = null)"
                    >
                    {{ $t('platforms').tTitle() }}
                  </router-link>
                  <!-- </Button> -->
                  <Button v-if="item.platform == 'mt4' || item.platform == 'mt5' || item.platform == 'trl'" mode="primary-white" customClasses="leading-6 !font-normal !py-2 mb-2">
                    <a @click="(activeTooltip = null)" :href="item.platform == 'mt4' ? mt4WebTraderLinks : item.platform == 'mt5' ? mt5WebTraderLinks : 'https://live.tradelocker.com/auth/login'" target="_blank">
                      {{ item.platform == 'trl' ? $t('launch_tradelocker').tTitle() : $t('launch_webtrader').tTitle() }}
                    </a>
                  </Button>
                  <Button
                    mode="primary-white"
                    customClasses="leading-6 !font-normal !py-2"
                    @click="(activeTooltip = null),
                      $refs.viewTradesModalDashboard.openModal(item.external_id, item.platform, item.type, item.account_type_identifier === 'no-deposit-bonus' ? true : false)
                    "
                  >
                    {{ $t('view_trades').tTitle() }}
                  </Button>
                  <a
                    v-if="item.account_type_identifier == 'copy-trading-provider' || item.account_type_identifier == 'copy-trading-follower'"
                    href="https://social-trading.plexytrade.com/"
                    @click="(activeTooltip = null)"
                    target="_blank"
                    class="w-full hover:bg-blue rounded-md text-gray-900 hover:text-white text-center appearance-none py-2 text-base leading-6 mt-2 table"
                    >{{ $t('copy_trading_dashboard_link').tTitle() }}</a
                  >
                  <Button
                    mode="primary-white"
                    customClasses="leading-6 !font-normal !py-2"
                    v-if="item.type === 'demo'"
                    @click="(activeTooltip = null), openEditDemoBalanceModal(User.info.ID, item.external_id, item.balance, currencySymbols[item.currency])"
                  >
                    {{ $t('edit').tTitle() }}
                  </Button>
                  <!-- <a
                      v-if="item.account_type_identifier == 'pamm-investor' || item.account_type_identifier == 'pamm-master'"
                      href="https://pamm.plexytrade.com/"
                      target="_blank"
                      class="w-full hover:bg-blue rounded-md text-gray-900 hover:text-white text-center appearance-none py-2 text-base leading-6 mt-2 table"
                      >{{ $t('pamm_dashboard').tTitle() }}</a
                    > -->

                </div>
              </div>
            </div>
          </Carousel>
          <div v-if="filteredTradingAccounts.length == 0" class="text-center text-base text-blue font-semibold py-4 md:pt-36">
            {{ $t('no_records') }}
          </div>
        </div>

        <div class="w-auto l150:w-full bg-white rounded-lg shadow-ts1 mx-2 md:mx-0 pt-8 pb-8 md:pb-6">
            <div class="flex justify-between md:items-center flex-col md:flex-row gap-3 md:gap-0 pb-4 border-b border-solid border-gray-400">
              <p class="ltr:pl-7 rtl:pr-7 text-gray-900 font-display font-bold text-xl leading-none">{{ $t('trading_journal') }}</p>
              <div class="ltr:pl-7 lg:ltr:pr-7 rtl:pr-7 lg:rtl:pl-7">
                <div class="text-base text-gray-900 flex gap-1 font-semibold">
                  <div class="flex gap-1 relative items-center">
                    <div @mouseover="openTooltip = true" @mouseleave="openTooltip = false" class="hidden lg:block">
                      <img class="w-[13px] h-[13px]" src="../assets/img/icons/upload/info.svg" alt="Additional info" />
                    </div>
                    <div class="w-[217px] absolute top-6 right-[77%] z-[1]">
                    <div
                      v-if="openTooltip"
                      class="font-body text-sm text-gray-900 text-left font-normal m-auto lg:m-0 lg:float-right bg-white rounded-lg shadow-ts3 w-full p-3 object-right-bottom">
                      {{ $t('close_trades') }}
                    </div>
                  </div>
                    <p>{{ $t('total_pnl') }}:</p>
                  </div>
                  <div v-if="totalPnL != ''">
                    <div v-for="(total, currency) in totalPnL" :key="currency">
                      <span :class="[total >= 0 ? 'text-green' : 'text-red-error']">{{ $formatMoney(total.toFixed(2), currencySymbols[currency]) }}</span>
                    </div>
                  </div>
                  <div v-else-if="User.wallet.currency">{{ currencySymbols[User.wallet.currency].symbol }}0</div>
                  <div v-else>0</div>
                </div>
              </div>
            </div>
            <div class="p-[30px]">
              <FullCalendar ref="fullCalendar" :options="calendarOptions" />
            </div>
          </div>

        <div v-if="showPlatforms" class="w-auto bg-white rounded-lg shadow-ts1 pt-5 pb-7 mb-7 mx-2 block l150:hidden">
          <div class="flex justify-between items-center pb-4 border-b border-solid border-gray-300">
            <div>
              <p class="ltr:pl-5 rtl:pr-5 text-blue font-display font-bold text-xl">{{ $t('platforms') }}</p>
            </div>

            <router-link :to="'/' + Language + '/trading-account/download'" class="ltr:pr-5 ltr:l150:pr-8 rtl:pl-5 rtl:l150:pl-8 font-semibold text-gray-900 text-sm">{{
              $t('learn_more')
            }}</router-link>
          </div>
          <div class="relative overflow-hidden">
            <div id="step1Mobile" class="transition-all duration-300 ease-in-out">
              <p class="text-gray-900 text-base pb-6 ltr:pl-5 rtl:pr-5 pt-5">{{ $t('select_operating_system') }}</p>
              <div class="ltr:ml-5 rtl:mr-5 flex spacing-x-2">
                <div class="w-[108px] cursor-default" @click="gotoStep2('windows')">
                  <div class="py-4 px-8 mb-3 bg-white rounded-lg border border-gray-300 relative group ltr:mr-2 rtl:ml-2">
                    <img class="w-full" src="../assets/img/windows.svg" />
                    <div class="w-full bg-blue bg-opacity-85 absolute inset-0 text-center rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
                      <div class="table w-full h-full text-center">
                        <p class="text-white font-bold text-xs pt-7">Windows</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-[108px] cursor-default" @click="gotoStep2('android')">
                  <div class="py-4 px-8 mb-3 bg-white rounded-lg border border-gray-300 relative group ltr:mr-2 rtl:ml-2">
                    <img class="w-full" src="../assets/img/android.svg" />
                    <div class="w-full bg-blue bg-opacity-85 absolute inset-0 text-center rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
                      <div class="table w-full h-full text-center">
                        <p class="text-white font-bold text-xs pt-7">Android</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-[100px] cursor-default" @click="gotoStep2('ios')">
                  <div class="py-4 px-8 mb-3 bg-white rounded-lg border border-gray-300 relative group">
                    <img class="w-full" src="../assets/img/apple.svg" />
                    <div class="w-full bg-blue bg-opacity-85 absolute inset-0 text-center rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
                      <div class="table w-full h-full text-center">
                        <p class="text-white font-bold text-xs pt-7">iOS</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="step2Mobile" class="absolute w-full ltr:left-full rtl:right-full top-0 transition-all duration-300 ease-in-out">
              <p class="text-gray-900 text-base pb-6 ltr:pl-5 rtl:pr-5 pt-5">{{ $t('select_platform') }}</p>
              <div class="ltr:ml-5 rtl:mr-5 flex spacing-x-2.5 relative">
                <div @click="gotoStep1()" class="absolute ltr:-left-3 rtl:-right-3 top-1/3 z-10 cursor-pointer">
                  <img src="/static/img/arrow.svg" class="w-2 rotate-180" />
                </div>
                <div class="w-[108px] cursor-default" @click="downloadPlatform('mt4')">
                  <div class="py-4 px-8 mb-3 bg-white rounded-lg border border-gray-300 relative group ltr:mr-2 rtl:ml-2">
                    <img class="w-full" src="../assets/img/mt4.svg" />
                    <div class="w-full bg-blue bg-opacity-85 absolute inset-0 text-center rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
                      <div class="table w-full h-full text-center">
                        <p class="text-white font-bold text-xs pt-7">MetaTrader 4</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-[108px] cursor-default" @click="downloadPlatform('mt5')">
                  <div class="py-4 px-8 mb-3 bg-white rounded-lg border border-gray-300 relative group ltr:mr-2 rtl:ml-2">
                    <img class="w-full" src="../assets/img/mt5.svg" />
                    <div class="w-full bg-blue bg-opacity-85 absolute inset-0 text-center rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
                      <div class="table w-full h-full text-center">
                        <p class="text-white font-bold text-xs pt-7">MetaTrader 5</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-[100px] cursor-default">
                  <div class="py-4 px-8 mb-3 bg-white rounded-lg"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="ltr:ml-5 rtl:mr-5 flex space-x-1 rtl:space-x-reverse mb-6">
            <div @click="gotoStep1()" :class="[showDownloadStep1 ? 'bg-blue w-5' : 'w-2.5 bg-gray-300']" class="h-0.5 rounded-xl cursor-pointer"></div>
            <div :class="[!showDownloadStep1 ? 'bg-blue w-5' : 'w-2.5 bg-gray-300']" class="h-0.5 rounded-xl"></div>
          </div>
          <a id="downloadLinkMobile" target="_blank" class="bg-gray-300 text-center text-white rounded-md py-3 w-40 text-base font-bold table ltr:ml-5 rtl:mr-5">{{
            $t('download').tTitle()
          }}</a>
        </div>

        <div
          class="w-auto l150:w-full bg-white rounded-lg shadow-ts1 mx-2 md:mx-0 px-5 l150:px-8 pt-8 pb-8 md:pb-6 hidden justify-center md:justify-between items-center flex-col l150:flex-row"
        >
          <div class="w-full md:w-[85%] break-words l150:w-auto">
            <p class="font-display font-bold text-[2.5rem] leading-none text-blue text-center ltr:l150:text-left rtl:l150:text-right hidden md:block">
              <span class="text-green">120%</span> {{ $t('welcome_bonus') }}
            </p>
            <p v-html="$t('welcome_bonus_breakline')" class="font-display font-bold text-[2.76rem] leading-[47px] text-blue text-center block md:hidden"></p>
          </div>
          <div>
            <a
              :href="promotionWelcomeBonusURL"
              target="_blank"
              class="w-40 bg-green text-center text-white text-base font-bold rounded-md py-4 mt-11 md:mt-5 l150:mt-0 table l150:block"
              >{{ $t('learn_more') }}</a
            >
          </div>
        </div>

      </div>
      <div class="w-full l150:w-[calc(33.33%-22px)] pr-2 l150:h-[755px] flex flex-col l150:justify-around">
        <div class="bg-white rounded-lg shadow-ts1 hidden l150:block pt-5 mb-7">
          <div class="pb-4 border-b border-solid border-gray-400">
            <div>
              <p class="ltr:pl-7 rtl:pr-7 text-gray-900 font-display font-bold text-xl leading-none">{{ $t('quick_links') }}</p>
            </div>
          </div>
          <div class="w-auto pt-5 pb-3 mt-3.5 mb-3.5" id="carousel2">
            <VueSlickCarousel v-bind="carouselSettings" @init="onInitCarousel2" @reInit="onInitCarousel2" class="w-[95vw] md:w-full">
              <div class="pb-3 relative">
                <p :class="[Language == 'es' ? 'w-[123px]' : 'w-full']" class="item-title text-gray-900 text-xs text-center mb-3 font-medium absolute">
                  {{ $t('internal_transfer').tTitle() }}
                </p>
                <div class="item-icon h-[4.4rem] w-[4.4rem] bg-white rounded-xl shadow-ts3 m-auto mt-10">
                  <img class="w-full" src="../assets/img/internal-transfer.svg" />
                </div>

                <router-link :to="'/' + Language + '/finance/internal-transfer'" class="active-icon h-20 w-20 bg-gray-900 rounded-xl shadow-ts3 m-auto hidden mt-8">
                  <img class="w-full" src="../assets/img/internal-transfer-b.svg" />
                </router-link>
              </div>
              <div class="pb-3 relative">
                <p :class="[Language == 'es' ? 'w-[123px]' : 'w-full']" class="item-title text-gray-900 text-sm text-center mb-3 font-medium absolute">
                  {{ $t('account_list').tTitle() }}
                </p>
                <div class="item-icon h-[4.4rem] w-[4.4rem] bg-white rounded-xl shadow-ts3 m-auto mt-10">
                  <img class="w-full" src="../assets/img/account-list.svg" />
                </div>
                <router-link :to="'/' + Language + '/trading-account'" class="active-icon h-20 w-20 bg-gray-900 rounded-xl shadow-ts3 m-auto hidden mt-8">
                  <img class="w-full" src="../assets/img/account-list-b.svg" />
                </router-link>
              </div>
              <!-- <div class="pb-3 relative">
                <p class="item-title w-full text-gray-900 text-sm text-center mb-3 font-medium absolute">{{ $t('video_courses') }}</p>
                <div class="item-icon h-[4.4rem] w-[4.4rem] bg-white rounded-xl shadow-ts3 m-auto mt-10">
                  <img class="w-full" src="../assets/img/video-courses.svg" />
                </div>
                <div class="active-icon h-20 w-20 bg-gray-900 rounded-xl shadow-ts3 m-auto hidden mt-8">
                  <img class="w-full" src="../assets/img/video-courses-b.svg" />
                </div>
              </div> -->
              <div class="pb-3 relative">
                <p class="item-title w-full text-gray-900 text-sm text-center mb-3 font-medium absolute">{{ $t('transactions') }}</p>
                <div class="item-icon h-[4.4rem] w-[4.4rem] bg-white rounded-xl shadow-ts3 m-auto mt-10">
                  <img class="w-full" src="../assets/img/transactions-icon.svg" />
                </div>
                <router-link :to="'/' + Language + '/finance/payment-history'" class="active-icon h-20 w-20 bg-gray-900 rounded-xl shadow-ts3 m-auto hidden mt-8">
                  <img class="w-full" src="../assets/img/transactions-icon-b.svg" />
                </router-link>
              </div>
              <div class="pb-3 relative">
                <p class="item-title w-full text-gray-900 text-sm text-center mb-3 font-medium absolute">{{ $t('profile') }}</p>
                <div class="item-icon h-[4.4rem] w-[4.4rem] bg-white rounded-xl shadow-ts3 m-auto mt-10">
                  <img class="w-full" src="../assets/img/my-settings-icon.svg" />
                </div>
                <router-link :to="'/' + Language + '/profile'" class="active-icon h-20 w-20 bg-gray-900 rounded-xl shadow-ts3 m-auto hidden mt-8">
                  <img class="w-full" src="../assets/img/my-settings-icon-b.svg" />
                </router-link>
              </div>
            </VueSlickCarousel>
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-ts1 py-8 md:py-10 px-5 md:px-8 mb-7 mx-2 md:mx-0">
          <div class="flex justify-center md:justify-between items-center flex-col-reverse md:flex-row">
            <div class="">
              <p class="font-display font-bold text-[1.75rem] leading-8 text-blue mb-8 text-center ltr:md:text-left rtl:md:text-right hidden md:block">
                <span class="text-green table">120%</span> {{ $t('welcome_bonus') }}
              </p>
              <p v-html="$t('welcome_bonus_breakline')" class="font-display font-bold text-3xl text-blue mb-4 text-center ltr:md:text-left rtl:md:text-right block md:hidden"></p>
              <a
                :href="promotionWelcomeBonusURL"
                target="_blank"
                class="w-28 py-0.5 table m-auto md:m-0 text-green rounded-xl bg-white hover:bg-[#20B38126] border border-green border-solid text-center text-sm font-medium"
                >{{ $t('learn_more') }}</a>
            </div>
            <img src="../assets/img/120-cash-bonus.svg" class="h-[81px] w-[81px] mb-5 md:mb-0" />
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-ts1 py-8 md:py-10 px-5 md:px-8 mb-7 mx-2 md:mx-0">
          <div class="flex justify-center md:justify-between items-center flex-col-reverse md:flex-row">
            <div class="">
              <p
                v-html="$t('vps_hosting_service_dashboard')"
                class="font-display font-bold text-[1.75rem] leading-8 text-blue mb-8 text-center ltr:md:text-left rtl:md:text-right hidden md:block"
              ></p>
              <p
                v-html="$t('vps_hosting_service_dashboard_mobile')"
                class="font-display font-bold text-3xl text-blue mb-4 text-center ltr:md:text-left rtl:md:text-right block md:hidden"
              ></p>
              <router-link
                :to="'/' + Language + '/trading-account/vps'"
                class="w-28 py-0.5 table m-auto md:m-0 text-green rounded-xl bg-white hover:bg-[#20B38126] border border-green border-solid text-center text-sm font-medium"
                >{{ $t('order_now') }}</router-link
              >
            </div>
            <img src="../assets/img/vps.svg" class="h-[81px] w-[81px] mb-5 md:mb-0" />
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-ts1 py-8 md:py-10 px-5 md:px-8 mb-7 mx-2 md:mx-0">
          <div class="flex justify-center md:justify-between items-center flex-col-reverse md:flex-row">
            <div class="">
              <p
                class="font-display font-bold text-[1.75rem] leading-8 text-blue mb-8 text-center ltr:md:text-left rtl:md:text-right hidden md:block"
              ><span class="text-green table">PAMM</span> {{ $t('programme') }}</p>
              <p
                v-html="$t('pamm_breakline')"
                class="font-display font-bold text-3xl text-blue mb-4 text-center ltr:md:text-left rtl:md:text-right block md:hidden"
              ></p>
              <a
                :href="pammURL"
                target="_blank"
                class="w-28 py-0.5 table m-auto md:m-0 text-green rounded-xl bg-white hover:bg-[#20B38126] border border-green border-solid text-center text-sm font-medium"
                >{{ $t('learn_more') }}</a>
            </div>
            <img src="../assets/img/pamm-dashboard.svg" class="h-[81px] w-[81px] mb-5 md:mb-0" />
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-ts1 py-8 md:py-9 ps-5 md:ps-8 mx-2 md:mx-0">
          <trading-central-component :isPopup="false" />
        </div>

        <div v-if="showPlatforms" class="w-auto bg-white rounded-lg shadow-ts1 pt-5 pb-3 ltr:l150:ml-8 rtl:l150:mr-8 hidden l150:block">
          <div class="flex justify-between items-center pb-4 border-b border-solid border-gray-300">
            <div>
              <p class="ltr:pl-7 rtl:pr-7 text-blue font-display font-bold text-xl">{{ $t('platforms') }}</p>
            </div>

            <router-link :to="'/' + Language + '/trading-account/download'" class="ltr:pr-8 rtl:pr-8 font-semibold text-gray-900 text-sm">{{ $t('learn_more') }}</router-link>
          </div>
          <div class="relative overflow-hidden">
            <div id="step1" class="transition-all duration-300 ease-in-out">
              <p class="text-gray-900 text-base pb-6 ltr:pl-7 rtl:pr-7 pt-5">{{ $t('select_operating_system') }}</p>
              <div class="mx-7 flex spacing-x-2.5 gap-2">
                <div class="w-1/3 cursor-default flex-shrink-0" @click="gotoStep2('windows')">
                  <div class="py-[22px] w-full mb-3 bg-white rounded-lg border border-gray-300 relative group ltr:mr-2.5 rtl:ml-2.5">
                    <img class="w-11 m-auto" src="../assets/img/windows.svg" />
                    <div class="w-full bg-blue bg-opacity-85 absolute inset-0 text-center rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
                      <div class="table w-full h-full text-center">
                        <p class="text-white font-bold text-xs pt-9">Windows</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/3 cursor-default flex-shrink-0" @click="gotoStep2('android')">
                  <div class="py-[22px] w-full mb-3 bg-white rounded-lg border border-gray-300 relative group ltr:mr-2.5 rtl:ml-2.5">
                    <img class="w-11 m-auto" src="../assets/img/android.svg" />
                    <div class="w-full bg-blue bg-opacity-85 absolute inset-0 text-center rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
                      <div class="table w-full h-full text-center">
                        <p class="text-white font-bold text-xs pt-9">Android</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/3 cursor-default flex-shrink-0" @click="gotoStep2('ios')">
                  <div class="py-[22px] w-full mb-3 bg-white rounded-lg border border-gray-300 relative group ltr:mr-2.5 rtl:ml-2.5">
                    <img class="w-11 m-auto" src="../assets/img/apple.svg" />
                    <div class="w-full bg-blue bg-opacity-85 absolute inset-0 text-center rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
                      <div class="table w-full h-full text-center">
                        <p class="text-white font-bold text-xs pt-9">iOS</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="step2" class="absolute w-full ltr:left-full rtl:right-full top-0 transition-all duration-300 ease-in-out">
              <p class="text-gray-900 text-base pb-6 ltr:pl-7 rtl:pr-7 pt-5">{{ $t('select_platform') }}</p>
              <div class="mx-7 flex spacing-x-2.5 gap-2 relative">
                <div @click="gotoStep1()" class="absolute ltr:-left-4 rtl:-right-4 top-1/3 z-10 cursor-pointer">
                  <img src="/static/img/arrow.svg" class="w-2 rotate-180" />
                </div>
                <div class="w-1/3 cursor-default flex-shrink-0" @click="downloadPlatform('mt4')">
                  <div class="py-[22px] w-full mb-3 bg-white rounded-lg border border-gray-300 relative group ltr:mr-2.5 rtl:ml-2.5">
                    <img class="w-11 m-auto" src="../assets/img/mt4.svg" />
                    <div class="w-full bg-blue bg-opacity-85 absolute inset-0 text-center rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
                      <div class="table w-full h-full text-center">
                        <p class="text-white font-bold text-xs pt-9">MetaTrader 4</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/3 cursor-default flex-shrink-0" @click="downloadPlatform('mt5')">
                  <div class="py-[22px] w-full mb-3 bg-white rounded-lg border border-gray-300 relative group ltr:mr-2.5 rtl:ml-2.5">
                    <img class="w-11 m-auto" src="../assets/img/mt5.svg" />
                    <div class="w-full bg-blue bg-opacity-85 absolute inset-0 text-center rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
                      <div class="table w-full h-full text-center">
                        <p class="text-white font-bold text-xs pt-9">MetaTrader 5</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/3 cursor-default flex-shrink-0">
                  <div class="py-[22px] w-full mb-3 bg-white ltr:mr-2.5 rtl:ml-2.5"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="ltr:ml-7 rtl:mr-7 flex space-x-1 rtl:space-x-reverse mb-6">
            <div @click="gotoStep1()" :class="[showDownloadStep1 ? 'bg-blue w-5' : 'w-2.5 bg-gray-300']" class="h-0.5 rounded-xl cursor-pointer"></div>
            <div :class="[!showDownloadStep1 ? 'bg-blue w-5' : 'w-2.5 bg-gray-300']" class="h-0.5 rounded-xl"></div>
          </div>
          <a id="downloadLink" target="_blank" class="bg-gray-300 text-center text-white rounded-md py-3 w-40 text-base font-bold table ltr:ml-7 rtl:mr-7 mb-4">{{
            $t('download').tTitle()
          }}</a>
        </div>
      </div>
    </div>

    <change-password-modal v-if="changeTAPassword.modalActive" :TAPasswordData="changeTAPassword"></change-password-modal>

    <create-account-modal @close="closeModal" @complete="refreshTAs" v-show="showCreateAccountModal"></create-account-modal>

    <view-trades-modal ref="viewTradesModalDashboard"></view-trades-modal>

    <transfer-back-modal v-if="transferBack.modalActive" :transferBackData="transferBack" @complete="refreshTAs"> </transfer-back-modal>

    <edit-demo-balance-modal v-if="editDemoBalance.modalActive" :data="editDemoBalance.data" @complete="refreshTAs" @close="editDemoBalance.modalActive = false">
    </edit-demo-balance-modal>
  </div>
</template>

<script>
import { service } from '../main.js'
import { mapActions, mapGetters } from 'vuex'
import config from '../config'
import api from '../api'
import ChangePasswordModal from '../components/ChangePasswordModal.vue'
import CreateAccountModal from '../components/CreateAccountModal.vue'
import EditDemoBalanceModal from '../components/EditDemoBalanceModal.vue'
import ViewTradesModal from '../components/ViewTradesModal.vue'
import TransferBackModal from '../components/TransferBackModal.vue'
import TradingCentralComponent from '../components/TradingCentralComponent.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import links from '@/config/links.js'
import Button from '@/components/reusableComponents/Button.vue'
import ButtonGroup from '@/components/reusableComponents/ButtonGroup.vue'
import Carousel from '@/components/reusableComponents/Carousel.vue'
import Select from '@/components/reusableComponents/Select.vue'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'

export default {
  props: ['reason'],
  components: {
    VueSlickCarousel,
    ChangePasswordModal,
    CreateAccountModal,
    EditDemoBalanceModal,
    ViewTradesModal,
    TransferBackModal,
    TradingCentralComponent,
    Button,
    ButtonGroup,
    Carousel,
    Select,
    FullCalendar
  },
  data() {
    const today = new Date()
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1)
    return {
      showNewsletterProgressBar: true,
      showCreateAccountModal: false,
      showPlatforms: false,
      selectedAccountType: 'all',
      selectedPlatform: 'all',
      walletBalance: 0,
      // totalDeposits: 0,
      // totalTradingCentralDeposits: 0,
      // totalWithdrawals: 0,
      graphSwitched: false,
      showDownloadStep1: true,
      links: config.platformDownloadLinks,
      currencySymbols: config.currencies,
      selectedOperatingSystem: '',
      isRegistration: false,
      downloadLink: '',
      carouselSettings: {
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: '20px',
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 3,
        speed: 500,
        initialSlide: 2,
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 3,
              centerPadding: '20px',
            },
          },
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3,
              centerPadding: '0px',
            },
          },
          {
            breakpoint: 1270,
            settings: {
              slidesToShow: 3,
              centerPadding: '-15px',
            },
          },
          {
            breakpoint: 1180,
            settings: {
              slidesToShow: 3,
              centerPadding: '-30px',
            },
          },
          {
            breakpoint: 1080,
            settings: {
              slidesToShow: 3,
              centerPadding: '-35px',
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              centerPadding: '125px',
            },
          },
          {
            breakpoint: 590,
            settings: {
              slidesToShow: 3,
              centerPadding: '100px',
            },
          },
          {
            breakpoint: 535,
            settings: {
              slidesToShow: 3,
              centerPadding: '70px',
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              centerPadding: '20px',
            },
          },
        ],
      },
      filteredTradingAccounts: [],
      changeTAPassword: {
        modalActive: false,
        new: '',
        newConfirm: '',
        TAID: null,
      },
      transferBack: {
        modalActive: false,
        amount: 0,
        equity: 0,
        TAID: 0,
      },
      editDemoBalance: {
        modalActive: false,
        data: {
          userID: '',
          TAID: '',
          balance: '',
          prefix: '',
        },
      },
      newsletterMax: 500.0,
      isMobile: false,
      platforms: [
        { value: 'all', label: 'platform' },
        { value: 'mt4', label: 'MT4' },
        { value: 'mt5', label: 'MT5' },
        { value: 'pamm', label: 'PAMM' },
        { value: 'trl', label: 'Tradelocker' },
      ],
      activeTooltip: null,
      calendarOptions: {
        plugins: [dayGridPlugin],
        firstDay: 1,
        height: 450,
        contentHeight: 400,
        aspectRatio: 1.2,
        initialView: 'dayGridMonth',
        buttonText: {
          today: this.$t('today'),
        },
        events: [],
        datesSet: this.getTrades,
        validRange: {
          end: endOfMonth,
        },
        fixedWeekCount: false
      },
      totalPnL: [],
      openTooltip: false,
      showCopyTradingAttachedToTooltip: false
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      Bonuses: 'bonusconfig/bonusData',
      TA: 'user/TA',
      isIB: 'user/isIB',
      TotalTCDeposited: 'user/totalTCDeposited',
      TotalDeposited: 'user/totalDeposited',
      TotalWithdrawals: 'user/totalWithdrawals',
    }),
    newsletterProgressPercentage() {
      return (Math.min(this.TotalTCDeposited, this.newsletterMax) / this.newsletterMax) * 100
    },
    newsletterProgressCurrency() {
      if (this.currencySymbols && this.User.wallet.currency) {
        const currencySymbol = this.currencySymbols[this.User.wallet.currency].symbol
        return `${this.$t('progress_towards').tTitle()} ${currencySymbol}${this.newsletterMax}`
      } else {
        return ''
      }
    },
    isRTL() {
      if (this.Language === 'fa') {
        return true
      } else {
        return false
      }
    },
    mt4WebTraderLinks() {
      return links.getLink('mt4WebTrader', 'en')
    },
    mt5WebTraderLinks() {
      return links.getLink('mt5WebTrader', 'en')
    },
    promotionWelcomeBonusURL() {
      return links.getLink('promotionWelcomeBonus', 'en')
    },
    pammURL() {
      return links.getLink('pamm', 'en')
    },
  },
  watch: {
    selectedPlatform() {
      this.filterAccounts()
    },
    selectedAccountType() {
      this.filterAccounts()
    },
    'User.info': {
      immediate: true,
      deep: true,
      async handler(u) {
        if (u.ID) {
          this.isUserSubscribed()
          // this['logoLoader/set'](true)

          await api.GetWallet().then(() => {
            this.walletBalance = Math.floor(this.User.wallet.balance * 100) / 100
            // this.getWalletTotals()
            // this['logoLoader/set'](false)
          })
          await api.GetBonusData().then(bonus => {
            this['bonusconfig/setBonusData'](bonus)
          })
          await api
            .GetTradingAccounts()
            .then(res => {
              this['user/setTA'](res.data.TAs)
              this.filterAccounts()
            })
            .catch(() => {
              // this['logoLoader/set'](false)
            })
        }
      },
    },
    $route() {
      this.isRegistration = typeof this.$route.meta.registerComponent !== 'undefined'
    },
    showCreateAccountModal(value) {
      if (value === true) {
        this.disableScroll()
      } else {
        this.enableScroll()
      }
    },
    'changeTAPassword.modalActive'(v) {
      if (v === true) {
        this.disableScroll()
      } else {
        this.enableScroll()
      }
    },
  },
  mounted() {
    this.dragContainer('#boxes')
    this.dragContainer('#promotionsContainer')
    this.onInitCarousel()
    this.onInitCarousel2()

    // if (typeof this.User.info.ID !== 'undefined') {
    //   api.GetWallet().then(() => {
    //     this.walletBalance = Math.floor(this.User.wallet.balance * 100) / 100
    //   })
    //   this['logoLoader/set'](true)
    //   api
    //     .GetTradingAccounts()
    //     .then(() => {
    //       this.getWalletTotals()
    //       this.filterAccounts()
    //       this['logoLoader/set'](false)
    //     })
    //     .catch(() => {
    //       this['logoLoader/set'](false)
    //     })
    // }
    this.filterAccounts()
    this.checkMobile()

    window.addEventListener('resize', this.checkMobile)
    // handle outside click for tooltips
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    // remove event listener for outside click
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 640
      // Always hide any visible tooltip on resize
      this.activeTooltip = null
    },
    async isUserSubscribed() {
      try {
        const response = await service.post('/tradingcentral/is-user-subscribed', { user_id: this.User.info.ID })
        if (response && response.data) {
          this.showNewsletterProgressBar = response.data
        }
      } catch (error) {
        this.$toasted.error(this.$t('sub_status_check_fail') + error)
      }
    },
    filterAccounts() {
      this.filteredTradingAccounts = []

      for (let i = 0; i < this.TA?.length; i++) {
        const account = this.TA[i]

        if (
          (account.platform === this.selectedPlatform || this.selectedPlatform === 'all') &&
          (account.type === this.selectedAccountType || this.selectedAccountType === 'all') &&
          this.TA[i].platform != 'transfer' &&
          account.status_enabled
        ) {
          if (account.platform === 'trl') {
            // check if the string has ('-')
            const hasDash = account.account_type.includes('-')
            if (hasDash) {
              // Extract the leverage and account_type and split them
              const spiltString = account.account_type.split('-')
              const leverage = parseInt(account.account_type.split('-').pop())
              const accountType = spiltString[0]

              // Dynamically update the leverage and modify the account_type
              account.leverage = leverage
              account.account_type = accountType
            }
          }

          this.filteredTradingAccounts.push(account)
        }
      }
    },
    // show the correct tooltip for actions
    showActionsTooltip(ta) {
      this.activeTooltip = this.activeTooltip === ta ? null : ta
    },
    // close tooltip when clicking outside
    handleOutsideClick(event) {
      const clickedInsideTooltip = event.target.closest('.tooltip-icon') || event.target.closest('.actions-tooltip')
      if (!clickedInsideTooltip) {
        this.activeTooltip = null
      }
    },
    onInitCarousel() {
      setTimeout(() => {
        let itemTitles = document.querySelectorAll('#carousel1 .slick-slide .item-title')
        let itemActiveIcons = document.querySelectorAll('#carousel1 .slick-slide .active-icon')
        let itemIcons = document.querySelectorAll('#carousel1 .slick-slide .item-icon')

        let selectedItemTitle = document.querySelector('#carousel1 .slick-current .item-title')
        let selectedItemIcon = document.querySelector('#carousel1 .slick-current .item-icon')
        let selectedActiveItemIcon = document.querySelector('#carousel1 .slick-current .active-icon')

        for (let i = 0; i < itemTitles.length; i++) {
          itemTitles[i].classList.add('opacity-0')
          itemIcons[i].classList.remove('hidden')
          itemActiveIcons[i].classList.add('hidden')
          itemActiveIcons[i].classList.remove('table')
          selectedItemIcon.classList.remove('hidden')
        }

        selectedItemTitle.classList.remove('opacity-0')

        selectedItemIcon.classList.add('hidden')
        selectedActiveItemIcon.classList.remove('hidden')
        selectedActiveItemIcon.classList.add('table')
      }, 10)
    },
    onInitCarousel2() {
      setTimeout(() => {
        let itemTitles = document.querySelectorAll('#carousel2 .slick-slide .item-title')
        let itemActiveIcons = document.querySelectorAll('#carousel2 .slick-slide .active-icon')
        let itemIcons = document.querySelectorAll('#carousel2 .slick-slide .item-icon')

        let selectedItemTitle = document.querySelector('#carousel2 .slick-current .item-title')
        let selectedItemIcon = document.querySelector('#carousel2 .slick-current .item-icon')
        let selectedActiveItemIcon = document.querySelector('#carousel2 .slick-current .active-icon')

        for (let i = 0; i < itemTitles.length; i++) {
          itemTitles[i].classList.add('opacity-0')
          itemIcons[i].classList.remove('hidden')
          itemActiveIcons[i].classList.add('hidden')
          itemActiveIcons[i].classList.remove('table')
          selectedItemIcon.classList.remove('hidden')
        }

        selectedItemTitle.classList.remove('opacity-0')
        selectedItemIcon.classList.add('hidden')
        selectedActiveItemIcon.classList.remove('hidden')
        selectedActiveItemIcon.classList.add('table')
      }, 10)
    },
    gotoStep1() {
      this.showDownloadStep1 = true
      this.selectedOperatingSystem = ''

      let step1 = document.getElementById('step1')
      let step1Mobile = document.getElementById('step1Mobile')
      let step2 = document.getElementById('step2')
      let step2Mobile = document.getElementById('step2Mobile')

      step1.classList.remove('-translate-x-full')
      step1Mobile.classList.remove('-translate-x-full')

      step2.classList.add('left-full')
      step2Mobile.classList.add('left-full')

      step2.classList.remove('left-0')
      step2Mobile.classList.remove('left-0')

      let downloadLink = document.getElementById('downloadLink')
      let downloadLinkMobile = document.getElementById('downloadLinkMobile')

      downloadLink.classList.add('bg-gray-300')
      downloadLink.classList.remove('bg-green')
      downloadLink.removeAttribute('href')

      downloadLinkMobile.classList.add('bg-gray-300')
      downloadLinkMobile.classList.remove('bg-green')
      downloadLinkMobile.removeAttribute('href')
    },
    gotoStep2(os) {
      this.selectedOperatingSystem = os

      let step1 = document.getElementById('step1')
      let step1Mobile = document.getElementById('step1Mobile')
      let step2 = document.getElementById('step2')
      let step2Mobile = document.getElementById('step2Mobile')

      step1.classList.add('-translate-x-full')
      step1Mobile.classList.add('-translate-x-full')

      step2.classList.remove('left-full')
      step2Mobile.classList.remove('left-full')

      step2.classList.add('left-0')
      step2Mobile.classList.add('left-0')

      this.showDownloadStep1 = !this.showDownloadStep1
    },
    downloadPlatform(platform) {
      let downloadLink = document.getElementById('downloadLink')
      let downloadLinkMobile = document.getElementById('downloadLinkMobile')

      if (platform == 'mt4') {
        if (this.selectedOperatingSystem == 'windows') {
          downloadLink.href = this.links.mt4.windows
        } else if (this.selectedOperatingSystem == 'android') {
          downloadLink.href = this.links.mt4.android + '=' + this.Language
        } else if (this.selectedOperatingSystem == 'ios') {
          downloadLink.href = this.links.mt4.ios
        }
      } else if (platform == 'mt5') {
        if (this.selectedOperatingSystem == 'windows') {
          downloadLink.href = this.links.mt5.windows
        } else if (this.selectedOperatingSystem == 'android') {
          downloadLink.href = this.links.mt5.android + '=' + this.Language
        } else if (this.selectedOperatingSystem == 'ios') {
          downloadLink.href = this.links.mt5.ios
        }
      }

      if (downloadLink.href != '') {
        downloadLink.classList.remove('bg-gray-300')
        downloadLinkMobile.classList.remove('bg-gray-300')
        downloadLink.classList.add('bg-green')
        downloadLinkMobile.classList.add('bg-green')
      }

      downloadLinkMobile.href = downloadLink.href
    },
    closeModal() {
      this.showCreateAccountModal = false
      document.getElementById('CAcontainer').classList.add('translate-x-full')
    },
    refreshTAs() {
      api.GetTradingAccounts().then(() => {
        // this.getUserBonuses()
        this.filterAccounts()
      })
    },
    showCAModal() {
      this.showCreateAccountModal = true
      setTimeout(() => document.getElementById('CAcontainer').classList.remove('translate-x-full'), 10)
    },
    newsletterSubscribe() {
      // this['logoLoader/text'](this.$t('logoloader_newsletter_subscribing').tTitle())
      // this['logoLoader/set'](true)
      service
        .post('tradingcentral/newsletter/request', {
          user_id: this.User.info.ID,
          // email: this.User.info.email,
          action: 'subscribe',
        })
        .then(response => {
          if (response) {
            if (response.data.is_active) {
              this.$toasted.success(this.$t('newsletter_sub_full').tTitle())
            } else {
              this.$toasted.success(
                this.$t('newsletter_sub_partial', {
                  amount: this.$formatMoney(response.data.remaining_deposit, this.currencySymbols[this.User.wallet.currency]),
                }).tTitle()
              )
            }

            if (response.data.is_active || response.data.remaining_deposit) {
              this.showNewsletterProgressBar = true
            }
          }
          // this['logoLoader/set'](false)
        })
        .catch(error => {
          this.$toasted.error(this.$t('news_sub_req_fail') + error)
          // this['logoLoader/set'](false)
        })
    },
    getTABonus(ta) {
      let amount = 0
      for (let i = 0; i < this.Bonuses.length; i++) {
        if (this.Bonuses[i].trading_account === ta) {
          if (this.Bonuses[i].status === 'granted') {
            return this.Bonuses[i].bonusAmount
          }
          amount = this.Bonuses[i].bonusAmount
        }
      }
      return amount
    },
    disableScroll() {
      document.querySelector('body').classList.add('overflow-hidden')
    },
    enableScroll() {
      document.querySelector('body').classList.remove('overflow-hidden')
    },
    openTransferBackModal(TAID, equity) {
      this.transferBack.modalActive = true
      this.transferBack.TAID = TAID
      this.transferBack.equity = equity
    },
    openEditDemoBalanceModal(userID, TAID, balance, prefix) {
      this.editDemoBalance.modalActive = true
      this.editDemoBalance.data = {
        userID: userID,
        TAID: TAID,
        balance: balance,
        prefix: prefix,
      }
    },
    async getTrades() {
      this.events = []
      this.totalPnL = []
      this.calendarOptions.events = []
      const calendarApi = this.$refs.fullCalendar?.getApi()
      const date = calendarApi.getDate()

      const month = date.getMonth() + 1
      const year = date.getFullYear()

      // var trades = [
      //   { pnl: 268.18, currency: 'USD', date: '2026-03-02' },
      //   { pnl: -200.18, currency: 'EUR', date: '2026-03-02' },
      //   { pnl: 289.02, currency: 'USD', date: '2026-03-04' },
      //   { pnl: -386.52, currency: 'EUR', date: '2026-03-05' },
      //   { pnl: 100.68, currency: 'USD', date: '2026-03-06' },
      // ]

      try {
        const response = await service.post('/users/trading-journal/pnl', { userID: this.User.info.ID, month: month, year: year })
        if (response && response.data) {
          this.events = response.data.trades.map(trade => ({
            title: `${this.currencySymbols[trade.currency].symbol}${trade.pnl}`,
            date: trade.date,
            classNames: [trade.pnl >= 0 ? 'profit-trade' : 'loss-trade'],
          }))
          this.calendarOptions.events = this.events
          this.totalPnL = response.data.trades.reduce((acc, trade) => {
            acc[trade.currency] = (acc[trade.currency] || 0) + trade.pnl
            return acc
          }, {})
          for (let currency in this.totalPnL) {
            this.totalPnL[currency] = Math.round(this.totalPnL[currency] * 100) / 100
          }
        }
      } catch (error) {
        // this.$toasted.error(this.$t('sub_status_check_fail') + error, { duration: 10000 })
      }
    },
    ...mapActions(['logoLoader/set', 'logoLoader/text', 'user/setTA', 'bonusconfig/setBonusData']),
  },
}
</script>
<style lang="css">
/* Dots */
.slick-dotted.slick-slider {
  margin-bottom: 30px;
}

.slick-dots {
  position: relative;

  display: block;

  width: 100%;
  padding: 0;
  margin: 0;

  list-style: none;

  text-align: center;
}

.slick-dots li {
  position: relative;

  display: inline-block;

  width: 10px;
  height: 20px;
  margin: 0 4px;
  padding: 0;

  cursor: pointer;
}

.slick-dots li button {
  font-size: 0;
  line-height: 0;

  display: block;

  width: 10px;
  height: 20px;
  padding: 5px;

  cursor: pointer;

  color: transparent;
  border: 0;
  outline: none;
  background: transparent;
}

.slick-dots li button:hover,
.slick-dots li button:focus {
  outline: none;
}

.slick-dots li button:hover:before,
.slick-dots li button:focus:before {
  opacity: 1;
}

.slick-dots li button:before {
  font-family: 'slick';
  font-size: 6px;
  line-height: 20px;

  position: absolute;
  top: 0;
  left: 0;

  width: 10px;
  height: 2px;

  content: '';
  text-align: center;

  background-color: #cfd9de;
  border-radius: 12px;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.slick-dots li.slick-active {
  width: 20px;
}

.slick-dots li.slick-active button:before {
  opacity: 1;
  width: 20px;
  background-color: #2b63e3;
  border-radius: 12px;
}

[dir='rtl'] .slick-slide[data-v-e4caeaf8] {
  float: left;
}

.noUserSelect {
  -webkit-user-select: none;
  -webkit-user-drag: none;
  -webkit-app-region: no-drag;
}

.fc-toolbar-title {
  @apply !text-lg text-blue font-body font-bold;
}

.fc-header-toolbar .fc-toolbar-chunk:last-child {
  @apply flex;
}

.fc .fc-button-primary {
  @apply !bg-transparent !border-transparent !shadow-none hover:!bg-opacity-80 dark:hover:!bg-opacity-20 !p-0 transition-all duration-300 ease-in-out;
}

.fc .fc-today-button {
  @apply !bg-blue !text-white !appearance-none dark:disabled:!text-white !rounded-md !inline-flex !shrink-0 !items-center !justify-center !w-[70px] !h-[34px] !font-semibold !text-base !p-0 disabled:!bg-blue disabled:!bg-opacity-20 !border-0 focus:!shadow-none disabled:text-opacity-100;
}
.fc .fc-daygrid-day-number {
  @apply !p-[5px];
}
.fc .fc-daygrid-day.fc-day-today {
  @apply !bg-blue !bg-opacity-15;
}

.fc * {
  @apply !border-gray-400;
}

.fc .profit-trade {
  @apply bg-green !border-green;
}

.fc .profit-trade .fc-event-main {
  @apply !text-white;
}

.fc .loss-trade {
  @apply bg-red-error !border-red-error;
}

.fc-button-group {
  @apply !p-0 gap-1.5;
}

.fc-icon-chevron-left::before {
  content: '';
  @apply h-6 w-6 bg-previous-arrow bg-no-repeat absolute left-0;
}

.fc-icon-chevron-right::before {
  content: '';
  @apply h-6 w-6 bg-next-arrow bg-no-repeat absolute right-0;
}

select[name='calendarType'] option {
  @apply pr-1.5;
}

select[name='calendarType'] option::checkmark {
  @apply mr-1.5;
}

.fc-h-event .fc-event-title {
  @apply text-[10px] leading-[10px] break-all whitespace-normal md:text-[1em] md:leading-[inherit] md:break-normal md:whitespace-nowrap;
}
</style>
